import { ProfileSubscriptionState } from 'constants/types';

export const checkIsActiveByState = (state: ProfileSubscriptionState) => [
  ProfileSubscriptionState.PAID,
  ProfileSubscriptionState.PARTIAL_PAID,
  ProfileSubscriptionState.MONTHLY_PAID,
  ProfileSubscriptionState.TRIAL,
  ProfileSubscriptionState.IS_SUSPENDED,
]?.some((sState) => sState === state);
